/** Partner catalogs: inventory (assets) and add-ons (extras). Mirrors backend partnerCatalogService. */
export const INVENTORY_CATEGORIES = ['car', 'yacht', 'villa', 'aviation', 'experience', 'restaurant', 'event', 'other'];

export const ADDON_CATEGORIES = ['transfer', 'experience', 'dining', 'wellness', 'upgrade', 'insurance', 'equipment', 'other'];

export const CATALOG_CONFIGS = {
  inventory: {
    kind: 'inventory',
    endpoint: '/partner-inventory',
    i18n: 'partnerInventory',
    categories: INVENTORY_CATEGORIES,
    defaultCategory: 'experience',
    showCapacity: true,
    imageFolder: 'partner-inventory',
    testIdPrefix: 'inventory',
  },
  addon: {
    kind: 'addon',
    endpoint: '/partner-addons',
    i18n: 'partnerAddonCatalog',
    categories: ADDON_CATEGORIES,
    defaultCategory: 'transfer',
    showCapacity: false,
    imageFolder: 'partner-addons',
    testIdPrefix: 'addon-catalog',
  },
};
